import React, { useEffect, useRef, useState } from 'react';
import { PublishingSongSplits } from './PublishingSongSplits';
import metaDataServices from '../MetaDataServices';
import Drawer from 'react-modern-drawer';
import { SongSplitsCollector } from './songSplitsCollector';
import DeleteDialogueBox from 'components/Common/deleteDialogue';
import songServices from '../Song/songServices';
import Modal from 'react-responsive-modal';

export function SongSplitsSearch(songSplitsSearch: any) {
    console.log(songSplitsSearch)

    let [saveTAlias, setsaveTAlias] = useState(false);
    let [totalSplitCss, settotalSplitCss] = useState(0);
    let [openSongSlit, setOpenSongSlit] = useState(false);
    let [songSplitsTotalRow, setSongSplitsTotalRow] = useState(0);
    let [selectedSongSlit, setSelectedSongSlit] = useState<any>([]);
    let [deleteSplitStatus, setdeleteSplitStatus] = useState(false);
    let [songSplitsListing, setSongSplitsListing] = useState<any>([]);
    let [deleteTerritoryAliase, setdeleteTerritoryAliase] = useState(false);
    let [openSongSplitsCollector, setopenSongSplitsCollector] = useState(false);
    let [selectedSongSplitSearch, setselectedSongSplitSearch] = useState<any>([]);

    var songSplitPayload = {
        songID: songSplitsSearch.data.songID,
        songName: songSplitsSearch.data.songName,
        songMainComposer: selectedSongSplitSearch.writerCode ? selectedSongSplitSearch.writerCode : "",
        songMainPublisher: selectedSongSplitSearch.publishers ? selectedSongSplitSearch.publishers : "",
        writerCode: selectedSongSplitSearch?.writerCode,
        publishers: selectedSongSplitSearch?.publishers,
        publishingLevel: 0,
        PageNumber: 1,
        PageSize: 10,
    }

    const closeSongSplitsSearch = () => { songSplitsSearch.closeSongSplitsSearch(); }

    useEffect(() => {
        console.log(songSplitsSearch)
        totalSplitCss = 0
        settotalSplitCss(totalSplitCss)

        if (songSplitsSearch.data) {
            selectedSongSplitSearch = songSplitsSearch.data
            setselectedSongSplitSearch(selectedSongSplitSearch)
        }

        if (songSplitsSearch?.opensongSplitsSearch) {
            searchSongSplit();
        }

    }, []);

    const searchSongSplit = () => {
        console.log(songSplitsSearch)

        totalSplitCss = 0
        settotalSplitCss(totalSplitCss)
        metaDataServices.songSplitsListing(songSplitPayload).then((values: any) => {
            setSongSplitsListing(values)
            setSongSplitsTotalRow(values && values[0] && values[0].totalRows ? values[0].totalRows : 0)
            for (var i = 0; values[i]; i++) {
                totalSplitCss = totalSplitCss + values[i]?.mechSplit
                settotalSplitCss(totalSplitCss)
            }
        })
    }


    const report701 = function () {
        var url = '/CrystalReport/CrystalReport701.aspx?template=Reports/Crystal701.rpt&format=PDF&songRef=' + songSplitsSearch.data.songRef;
        window.open(url);
    };

    const closePublishingSongSplits = () => { setOpenSongSlit(false); }

    const splitCollSave_YN = function (selectedSongSplit: any) {
        var sameCollector = {
            songPubTID: selectedSongSplit.songPubTID
            , collectorCode: selectedSongSplit.publishers
            , collectorType: selectedSongSplit.pubType
            , mechCollSplit: selectedSongSplit.mechSplit
            , perfCollSplit: selectedSongSplit.perfSplit
            , synchCollSplit: selectedSongSplit.synchSplit
            , printCollSplit: selectedSongSplit.printSplit
            , otherCollSplit: selectedSongSplit.otherSplit
            , merchCollSplit: selectedSongSplit.merchSplit
            , contractRefNum: selectedSongSplit.writersContract
            , controlledYN: selectedSongSplit.controlledYN

        };

        songServices.songSplitsCollSave(sameCollector).then(function (data) {
            searchSongSplit();
        });

    };

    const viewSongsSplitColl = function (split: any) {

    };

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...selectedSongSplitSearch };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        selectedSongSplitSearch = updatedObject;
        setselectedSongSplitSearch(selectedSongSplitSearch);


    };

    const closeSongSplitsCollectors = (e: any) => {
        openSongSplitsCollector = false;
        setopenSongSplitsCollector(openSongSplitsCollector)
    }

    let [deleteSplitStatusData, setdeleteSplitStatusData] = useState<any>([]);
    const deleteSongSplit = (e: any) => {
        deleteSplitStatusData = e;
        setdeleteSplitStatusData(deleteSplitStatusData)

        deleteSplitStatus = true;
        setdeleteSplitStatus(deleteSplitStatus)
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            //true
            songServices.publishingSongSplitDelete(deleteSplitStatusData?.songPubTID, { contactType: "" }).then(() => { searchSongSplit(); })
        }
        deleteSplitStatus = false;
        setdeleteSplitStatus(deleteSplitStatus)
    }

    return (

        <Modal open={songSplitsSearch.opensongSplitsSearch} onClose={closeSongSplitsSearch} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }}>

            <div className="ws-12 pull-right box landing" style={{ zIndex: 1100 }}>
                <div className="box-header-main"> <h2> Publishing Splits</h2> </div>

                <div className="box-content form-box ">
                    <div className="ws-12">

                        <fieldset className="scheduler-border p0 m0 ws-12">
                            <legend className="scheduler-border">
                                <h2 style={{ color: "#47529d" }} >  Song Info </h2>
                            </legend>

                            <div className="ws-12">

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-5 text-right pr">Song Ref : </label>
                                        <div className="label-entries ws-7">  {songSplitsSearch.data.songRef}  </div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-5 text-right pr">Song Title : </label>
                                        <div className="label-entries ws-7">  {songSplitsSearch.data.songName}  </div>
                                    </div>
                                </div>



                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-5 text-right pr">ISWC :  </label>
                                        <div className="label-entries ws-7"> {songSplitsSearch.data.intStdWorkCode} </div>
                                    </div>
                                </div>


                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-5 text-right pr">Main Composers :  </label>
                                        <div className="label-entries ws-7"> {songSplitsSearch.data.songMainComposer} </div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label ws-5 text-right pr">Main Publishers : </label>
                                        <div className="label-entries ws-7">  {songSplitsSearch.data.songMainPublisher}  </div>
                                    </div>
                                </div>
                            </div>

                        </fieldset>

                        <div className="ws-12 pm mtl box borderRounded">

                            <span className='text-bold'> Search within Song for Splits</span>
                            <hr></hr>

                            <div className="form-format ws-6">
                                <label className="control-label" >Main Composers</label>

                                <div className="label-entries">
                                    <input type="text" className="form-control text-uppercase" onChange={handleFieldChange} placeholder="Enter Composer/Writer" value={selectedSongSplitSearch.writerCode} id="Text3" name="writerCode" />
                                </div>
                            </div>

                            <div className="form-format ws-6">
                                <label className="control-label" > Main Publishers</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Publishers" id="Text2" onChange={handleFieldChange} name="publishers" value={selectedSongSplitSearch.publishers} />
                                </div>
                            </div>

                            <div className="ws-12 pull-right pm">
                                <button className="icon-btn delete pull-right" onClick={report701}><i className="icon-file-pdf-o"></i></button>
                                <button className="icon-btn edit pull-right" onClick={searchSongSplit}><i className="icon-search"></i> Search</button>
                                <button className="icon-btn delete pull-right" onClick={() => setselectedSongSplitSearch([])}> <i className="icon-reload"></i> Reset</button>
                            </div>
                        </div>

                        <div className="ws-12 mtl  box borderRounded">
                            <div className="box-header well">
                                <h2 className="ws-8"> {songSplitsTotalRow} record(s) found - Publishing Splits</h2>

                                <button className="btn icon-btn edit pull-right" onClick={() => { setOpenSongSlit(true); setSelectedSongSlit([]) }}>
                                    <i className="icon-plus1"></i> New Split
                                </button>
                            </div>

                            {saveTAlias && <div className="alert alert-success"> Work splits  has been saved successfully</div>}
                            {deleteTerritoryAliase && <div className="alert alert-success"> Work splits  has been deleted successfully</div>}
                            <div className="box-content ws-12">
                                {songSplitsTotalRow == 0 && <div className="alert alert-info">No splits to display for this track</div>}

                                {songSplitsTotalRow > 0 && <div className="table-responsive allowHscroll allowVscroll">
                                    <table className="newTable">
                                        <thead>
                                            <tr className="forceSingleLine">
                                                <th className="forceSingleLine">Composer/Writer</th>
                                                <th className="forceSingleLine">Type</th>
                                                <th className="forceSingleLine">Publisher</th>
                                                <th className="forceSingleLine">Type</th>
                                                <th className="forceSingleLine">Contract</th>
                                                <th className="forceSingleLine">Controlled</th>
                                                <th className="forceSingleLine">% Split </th>
                                                <th className="forceSingleLine">Mech</th>
                                                <th className="forceSingleLine">Perf</th>
                                                <th className="forceSingleLine">Sync</th>
                                                <th className="forceSingleLine">Print</th>
                                                <th className="forceSingleLine">Other</th>
                                                <th className="forceSingleLine">Merch</th>
                                                <th className="forceSingleLine">Operations</th>
                                                <th className="forceSingleLine">Same Collector</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {songSplitsListing.map((value: any) => {
                                                return (
                                                    <tr>
                                                        <td className="forceSingleLine text-uppercase"> {value.writerCodeDisplay} </td>
                                                        <td className="forceSingleLine">{value.contributionType} </td>
                                                        <td className="forceSingleLine text-uppercase">{value.publishersDisplay}</td>
                                                        <td className="forceSingleLine">{value.pubType}</td>
                                                        <td className="forceSingleLine">{value.contractTitle}</td>
                                                        <td className="forceSingleLine">{value.controlledYN}</td>
                                                        <td className="text-right bg-white">{value.publishingSplit}</td>
                                                        <td className="text-right">{value.mechSplit}</td>
                                                        <td className="text-right">{value.perfSplit}</td>
                                                        <td className="text-right">{value.synchSplit}</td>
                                                        <td className="text-right">{value.printSplit}</td>
                                                        <td className="text-right">{value.otherSplit}</td>
                                                        <td className="text-right">{value.merchSplit}</td>
                                                        <td>
                                                            <div className='width150'>
                                                                {(!value.subPublisersCount && false) && <button className="btn icon-btn edit btn-sm pull-left" data-ng-click="loadSubPublisherListing(split, splitIndex)">
                                                                    <i className="icon-eye"></i> View (0)
                                                                </button>}

                                                                {(!value.subPublisersCount && false) && <button className="icon-btn warning btn-sm pull-left">
                                                                    <i className="icon-eye"></i> View (0)
                                                                </button>}

                                                                <button className="btn icon-btn edit btn-sm pull-left hide" data-ng-click="subPublisherSplit(split)">
                                                                    <i className="icon-plus"></i> Sub Publishers
                                                                </button>

                                                                <a onClick={() => deleteSongSplit(value)} className="btn-sm icon-btn delete">  <i className="icon-trashcan"></i> </a>

                                                                <a onClick={() => { setOpenSongSlit(true); setSelectedSongSlit(value) }} className="btn-sm icon-btn edit"><i className="icon-edit"></i></a>

                                                                <a onClick={() => { setopenSongSplitsCollector(true); setSelectedSongSlit(value) }} className="btn-sm icon-btn edit"><i className="icon-eye"></i></a>
                                                            </div>

                                                        </td>
                                                        <td className="text-right">

                                                            {(value.collectedFlag === 0 || value.collectedFlag === 1) && <button className="icon-btn warning pull-right ml" onClick={() => splitCollSave_YN(value)}>Y </button>}
                                                            {(value.collectedFlag === 0 || value.collectedFlag === 2) && <button className="icon-btn warning pull-right ml" onClick={viewSongsSplitColl}>N</button>}

                                                        </td>
                                                    </tr>

                                                )
                                            })}

                                            <tr className="text-right text-bold text-xxl text-uppercase">
                                                <td className="text-right " colSpan={6}>Total</td>
                                                <td className="text-right bg-primary ">{totalSplitCss}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>}

                                <div className="clearfix">

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <div >

                    <div className="box-footer pull-right">
                        <button className="btn icon-btn delete btn-sm" onClick={closeSongSplitsSearch}><i className="icon-close"></i> Close</button>
                    </div>
                </div>

                {
                    (() => {
                        if (openSongSlit) {
                            return <PublishingSongSplits data={selectedSongSlit} song={songSplitsSearch.data} openPublishingSongSplits={openSongSlit} closePublishingSongSplits={closePublishingSongSplits} />
                        }

                        if (openSongSplitsCollector) {
                            return <SongSplitsCollector data={selectedSongSlit} song={songSplitsSearch.data} openSongSplitsCollector={openSongSplitsCollector} closeSongSplitsCollectors={closeSongSplitsCollectors} />
                        }

                        if (deleteSplitStatus) {
                            return <DeleteDialogueBox param={deleteSplitStatus} message={"to delete the following split"} onChange={Confirmation} />
                        }

                    })()
                }
            </div>

        </Modal>
    )

}